export const TABLE_ROWS_PER_PAGE = 50;

export enum ServiceFormType {
  membership = 'membership',
  package = 'package',
  trial = 'trial',
}